'use client';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { usePathname, useSearchParams } from 'next/navigation';
import React, { useState } from 'react';

import ExpensiveImage from '@/components/core/ExpensiveImage';
import { openGameProvider } from '@/components/core/OpenGame';
import { useAppRouter } from '@/components/hooks/useAppRouter';
import useClientTranslation from '@/components/hooks/useClientTranslation';

import ButtonBet from '@/app/[lng]/(general)/game/[slug]/components/PC/ButtonBet';
import ItemEsportPC from '@/app/[lng]/(general)/game/[slug]/components/PC/ItemEsportPC';
import { PARTNER_PROVIDER } from '@/constant/data';

const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.8,
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

const Esport: React.FC<any> = ({
  currentTab,
}: // params,
{
  params?: any;
  items?: any;
  currentTab?: any;
}) => {
  const listItem = currentTab.games;
  const { t } = useClientTranslation('HomePage');
  const { router } = useAppRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const page = searchParams.get('page') || PARTNER_PROVIDER.sbo;
  const [currentPage, setCurrentPage] = useState(page);
  const esport = currentPage === PARTNER_PROVIDER.esport;

  const handleClick = (data: any) => {
    setCurrentPage(data.partner_provider);

    router.push(`${pathname}?page=${data?.partner_provider}`);
  };
  const currentGameIndex = listItem.findIndex(
    (item: any) => item.partner_provider === currentPage
  );

  return (
    <div className='main-content relative flex h-full flex-col items-center justify-center'>
      <div className='left-0 right-0 top-0 h-full w-full select-none'>
        {esport ? (
          <div className='absolute inset-0 bottom-0 left-0 right-0 top-0 h-full w-full select-none bg-[#331725]'>
            <ExpensiveImage
              className='absolute left-0 right-0 top-0 h-full w-full min-w-[1280px] object-cover'
              width={1440}
              height={768}
              src='/img/game/sport/esport_background.png'
              images={[
                '/img/game/sport/small_esport_background.png',
                '/img/game/sport/small_esport_background.png',
                '/img/game/sport/esport_background.png',
              ]}
              alt='bg'
            />
          </div>
        ) : (
          <div className='absolute inset-0 bottom-0 left-0 right-0 top-0 h-full w-full select-none bg-[#93c0dd]'>
            <ExpensiveImage
              className='absolute inset-0 bottom-0 left-0 right-0 top-0 h-full w-full min-w-[1280px] object-cover'
              width={1440}
              height={768}
              src='/img/game/sport/virtual_background.png'
              images={[
                '/img/game/sport/small_virtual_background.png',
                '/img/game/sport/small_virtual_background.png',
                '/img/game/sport/virtual_background.png',
              ]}
              alt='bg'
            />
          </div>
        )}
      </div>

      <div className='container-pc relative flex min-h-[650px] items-center justify-center'>
        {esport ? (
          <div className='z-[1] mx-auto w-[60%]'>
            <motion.div
              variants={container}
              initial='hidden'
              animate='visible'
              className='absolute left-[160px] top-[10%] h-[474px] w-full select-none'
            >
              <motion.div variants={item}>
                <Image
                  height={373}
                  width={300}
                  priority
                  className='absolute -left-[150px] top-[30px] h-[373px] w-[300px] select-none'
                  src='/img/game/sport/character_1.png'
                  alt=''
                />
              </motion.div>
              <motion.div variants={item}>
                <Image
                  height={362}
                  width={286}
                  priority
                  className='absolute z-20 h-[362px] w-[286px] select-none'
                  src='/img/game/sport/character_2.png'
                  alt=''
                />
              </motion.div>
              <motion.div variants={item}>
                <Image
                  height={398}
                  width={418}
                  priority
                  className='absolute left-40 top-[30px] h-[398px] select-none'
                  src='/img/game/sport/character_3.png'
                  alt=''
                />
              </motion.div>
              <motion.div
                className='absolute left-[-20px] top-[300px] z-40 select-none'
                variants={item}
              >
                <motion.img
                  className='w-[345px]'
                  src='/img/game/sport/esport-text.png'
                  alt=''
                />

                <motion.div
                  className='mt-8 flex justify-center'
                  variants={item}
                  onClick={() =>
                    openGameProvider(
                      listItem?.[currentGameIndex > -1 ? currentGameIndex : 0],
                      router
                    )
                  }
                >
                  <ButtonBet color={2} t={t} />
                </motion.div>
              </motion.div>
            </motion.div>
          </div>
        ) : (
          <motion.div
            className='relative mx-auto h-[300px] w-[60%]'
            variants={container}
            initial='hidden'
            animate='visible'
          >
            <motion.div
              className='left-30 absolute top-0 w-full select-none'
              variants={item}
            >
              <img
                className='w-[350px]'
                src='/img/game/sport/virtual_text.png'
                alt=''
              />
            </motion.div>
            <motion.div
              onClick={() =>
                openGameProvider(
                  listItem?.[currentGameIndex > -1 ? currentGameIndex : 0],
                  router
                )
              }
              className='absolute bottom-4 left-[100px]'
              variants={item}
            >
              <ButtonBet color={2} t={t} />
            </motion.div>
          </motion.div>
        )}

        <div className='relative z-[3] flex w-[40%] min-w-[576px] justify-center gap-[58.33px] pb-20'>
          {listItem.map((_: any, i: number) => {
            return (
              <ItemEsportPC
                className=''
                onClick={handleClick}
                currentPage={currentPage}
                isButton={false}
                key={i}
                data={_}
                i={i}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Esport;
